module.exports = __webpack_public_path__ + "static/media/confidential@3x.3f679058.png";